import { render, staticRenderFns } from "./BottomRightTable2.vue?vue&type=template&id=553e4ed9&"
import script from "./BottomRightTable2.vue?vue&type=script&lang=js&"
export * from "./BottomRightTable2.vue?vue&type=script&lang=js&"
import style0 from "./BottomRightTable2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports